/*
 * Copyright (c) 2018-2023 MemberCenter, a subsidiary of Cameron Collective
 *   All Rights Reserved
 */
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import Snackbar from '@mui/material/Snackbar';
import SnackbarContent from '@mui/material/SnackbarContent';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { hideMessage } from 'store/slices/message.slice';

import { styles } from './styles';

const variantIcon = {
	success: 'check_circle',
	warning: 'warning',
	error: 'error_outline',
	info: 'info'
};

function Message() {
	const dispatch = useDispatch();
	const state = useSelector(({ message }) => message.state);
	const options = useSelector(({ message }) => message.options);

	return (
		<Snackbar
			{...options}
			open={state}
			onClose={() => dispatch(hideMessage())}
			sx={styles.root}
			ContentProps={{
				variant: 'body2',
				headlineMapping: {
					body1: 'div',
					body2: 'div'
				}
			}}
		>
			<SnackbarContent
				sx={styles[options.variant]}
				message={
					<div className="flex items-center">
						<Typography component={'span'} className="mx-8">
							{options.message}
						</Typography>
					</div>
				}
				action={[
					<IconButton key="close" aria-label="Close" color="inherit" onClick={() => dispatch(hideMessage())}>
						<CloseIcon />
					</IconButton>
				]}
			/>
		</Snackbar>
	);
}

export default React.memo(Message);
